<template lang="pug">
div
  h1.title Portaria de Homologação
  listagem(@changeProcessos="(processos) => this.processos = processos" tipo="PORTARIA_HOMOLOGACAO")
</template>
<script>
import Listagem from '@/screens/portal/publico/components/Listagem'

export default {

  data () {
    return {
      processos: [],
      isPa: process.env.ESTADO === 'pa'
    }
  },

  components: {
    Listagem
  },

  methods: {
    checkEstado (estado) {
      return process.env.ESTADO === estado
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/_variables.scss';

.title {
  color: $color-primary;
}

.main {
  color: $font-color;
  text-align: left;
  padding: 0 10% 0 10%;
  margin-bottom: 20px;
}

</style>



// WEBPACK FOOTER //
// src/screens/portal/publico/PortariaHomologacao.vue